/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'share': {
    width: 24,
    height: 25,
    viewBox: '0 0 24 25',
    data: '<path class="st0" d="M16.2,22.3H7.8c-1.8,0-2.8,0-3.6-0.4c-0.8-0.4-1.4-1-1.7-1.7C2,19.3,2,18.3,2,16.5v-4.2c0-0.6,0.4-1,1-1 s1,0.4,1,1v4.2c0,1.5,0,2.3,0.2,2.7c0.2,0.4,0.5,0.7,0.9,0.9c0.4,0.2,1.2,0.2,2.7,0.2h8.4c1.5,0,2.3,0,2.7-0.2 c0.4-0.2,0.7-0.5,0.9-0.9C20,18.8,20,18,20,16.5v-4.2c0-0.6,0.4-1,1-1s1,0.4,1,1v4.2c0,1.8,0,2.8-0.4,3.6c-0.4,0.8-1,1.4-1.7,1.7 C19,22.3,18,22.3,16.2,22.3z M12,16.3c-0.6,0-1-0.4-1-1V5.7L8.7,8c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l4-4c0.1-0.1,0.2-0.2,0.3-0.2 c0.1,0,0.2-0.1,0.4-0.1l0,0c0,0,0,0,0,0l0,0c0.1,0,0.3,0,0.4,0.1c0.1,0,0.2,0.1,0.3,0.2l4,4c0.4,0.4,0.4,1,0,1.4s-1,0.4-1.4,0 L13,5.7v9.6C13,15.9,12.6,16.3,12,16.3z"/>'
  }
})